import React from 'react'
import { Controller, useFormContext } from 'react-hook-form'
import ReactJson from 'react-json-view'

export const JsonInput = ({ source, defaultValue, viewOnly = false }) => {
  const { control } = useFormContext()
  return (
    <Controller
      name={source}
      control={control}
      defaultValue={defaultValue}
      render={({ field }) => (
        <div style={{ minWidth: 500, maxWidth:600 }}>
          <ReactJson
            src={field.value || {}}
            name={false}
            collapsed={false}
            enableClipboard
            displayDataTypes={false}
            onEdit={(edit) => field.onChange(edit.updated_src)}
            onAdd={(add) => field.onChange(add.updated_src)}
            onDelete={(del) => field.onChange(del.updated_src)}
            theme="rjv-default"
            style={{
              padding: '10px',
              border: '1px solid #ccc',
              borderRadius: 4,
            }}
            iconStyle="triangle"
            displayObjectSize={false}
            indentWidth={2}
            // modo solo lectura
            {...(viewOnly && {
              onEdit: false,
              onAdd: false,
              onDelete: false,
            })}
          />
        </div>
      )}
    />
  )
}
